import { useEffect, useState } from 'react';
import * as exerciseApi from '../../exercise-templates/api';
import { mergeBlocks, BLOCK_KIND_CONTAINER } from '../../exercise-templates/blockList';
import { safeParseContainerConfig } from '../../../variables/containerLayoutTypes';
import ContainerLayout from '../../../components/ContainerLayout';
import ExercisePreviewBlock from './ExercisePreviewBlock';

// A container's own children, arranged per its layout config - each child
// gets a light card boundary for the same legibility reason as
// TopicPreviewPanel.jsx's ContainerPreviewGroup.
function ExerciseContainerPreviewGroup({ container, elements, interactiveElements }) {
    const children = mergeBlocks(elements, interactiveElements, [], container.id);
    if (children.length === 0) return null;
    const config = safeParseContainerConfig(container.config, container.layout);
    return (
        <ContainerLayout layout={container.layout} config={config}>
            {children.map((entry) => (
                <div className='course-preview-container-item' key={entry.kind + '-' + entry.block.id}>
                    <ExercisePreviewBlock block={entry.block} />
                </div>
            ))}
        </ContainerLayout>
    );
}

// One linked ExerciseTemplate's own blocks, flattened - reuses the exact
// same static+interactive+container merge (mergeBlocks) the exercise-
// templates Builder itself uses, so ordering here matches the Builder 1:1.
export default function ExercisePreviewList({ exerciseTemplateId }) {
    const [elements, setElements] = useState([]);
    const [interactiveElements, setInteractiveElements] = useState([]);
    const [containers, setContainers] = useState([]);

    useEffect(() => {
        exerciseApi.getElements(exerciseTemplateId)
            .then((response) => setElements(Array.isArray(response.data) ? response.data : []))
            .catch(() => setElements([]));
        exerciseApi.getInteractiveElements(exerciseTemplateId)
            .then((response) => setInteractiveElements(Array.isArray(response.data) ? response.data : []))
            .catch(() => setInteractiveElements([]));
        exerciseApi.getContainers(exerciseTemplateId)
            .then((response) => setContainers(Array.isArray(response.data) ? response.data : []))
            .catch(() => setContainers([]));
    }, [exerciseTemplateId]);

    const merged = mergeBlocks(elements, interactiveElements, containers);

    if (merged.length === 0) {
        return <p className='course-preview-empty-hint'>Ця вправа ще порожня.</p>;
    }

    return (
        <div className='course-preview-timeline'>
            {merged.map((entry) => (
                entry.kind === BLOCK_KIND_CONTAINER
                    ? <ExerciseContainerPreviewGroup key={'container-' + entry.block.id} container={entry.block}
                        elements={elements} interactiveElements={interactiveElements} />
                    : <ExercisePreviewBlock key={entry.kind + '-' + entry.block.id} block={entry.block} />
            ))}
        </div>
    );
}
